module.exports = __webpack_public_path__ + "static/ourCustomer-6bfd3e94159a9879d458f02c03d8e2f4.png";